import buildRestProvider from "../shared/utilities/simpleRestProvider"

import {
  CreateParams,
  UpdateParams,
  DataProvider,
  fetchUtils,
} from "react-admin";
import { WeightReportOperation } from "../shared/types/types";

const fetchJson = (url, options: any = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  // add your own headers here
  options.headers.set("X-Correlation-Id", "foobar");
  options.headers.set("X-App-Id", "00e9396e-6c63-4834-8492-a1db4edc6421");
  options.headers.set(
    "Authorization",
    `Bearer ${localStorage.getItem("auth")?.toString()}`
  );
  return fetchUtils.fetchJson(url, options).catch(error => {
    // Extraer el mensaje del objeto ResponseError del backend
    if (error.body && error.body.message) {
      error.message = error.body.message;
    }
    throw error;
  });
};

const baseDataProvider = buildRestProvider(
  String(process.env.REACT_APP_API_URL),
  fetchJson
);

const createPostFormData = async (
  params:
    | CreateParams<WeightReportOperation>
    | UpdateParams<WeightReportOperation>
) => {
  const formData = new FormData();

  const weightReportOperation = params.data;

  // Para cada archivo: solo se sube si el usuario seleccionó uno nuevo (rawFile presente).
  // Si el archivo ya existe en el servidor (solo src, sin rawFile), NO se re-descarga
  // para evitar errores de red que causaban la desaparición de íconos de documentos.
  // El backend mantiene los archivos existentes mediante los IDs en el JSON.

  if (weightReportOperation.verificationListFile) {
    if (weightReportOperation.verificationListFile.rawFile) {
      formData.append(
        "verificationListFile",
        weightReportOperation.verificationListFile.rawFile!
      );
    }
  }

  if (weightReportOperation.dusCopy) {
    if (weightReportOperation.dusCopy.rawFile) {
      formData.append("dusCopy", weightReportOperation.dusCopy.rawFile!);
    }
  }

  if (weightReportOperation.customDeliveryLetter) {
    if (weightReportOperation.customDeliveryLetter.rawFile) {
      formData.append(
        "customDeliveryLetter",
        weightReportOperation.customDeliveryLetter.rawFile!
      );
    }
  }

  if (weightReportOperation.weightReport?.file) {
    if (weightReportOperation.weightReport?.file.rawFile) {
      formData.append(
        "weightReportFile",
        weightReportOperation.weightReport?.file.rawFile!
      );
    }
  }

  const otherFiles = weightReportOperation.otherFiles;
  if (otherFiles) {
    for (let i = 0; i < otherFiles.length; i++) {
      if (otherFiles[i] && otherFiles[i].rawFile) {
        formData.append("otherFiles", otherFiles[i].rawFile!);
      }
    }
  }

  formData.append(
    "weightReportOperation",
    new Blob([JSON.stringify(weightReportOperation)], {
      type: "application/json",
    })
  );
  return formData;
};

export const dataProvider: DataProvider = {
  ...baseDataProvider,
  create: async (resource, params) => {
    if (resource === "weightReportOperation") {
      const formData = await createPostFormData(params);
      return fetchJson(`${process.env.REACT_APP_API_URL}/${resource}`, {
        method: "POST",
        body: formData,
      }).then(({ json }) => ({ data: json }));
    }

    return baseDataProvider.create(resource, params);
  },
  update: async (resource, params) => {
    if (resource === "weightReportOperation") {
      const formData = await createPostFormData(params);
      return fetchJson(
        `${process.env.REACT_APP_API_URL}/${resource}/${params.id}`,
        {
          method: "PUT",
          body: formData,
        }
      ).then(({ json }) => ({ data: json }));
    }

    return baseDataProvider.update(resource, params);
  },
};
